import type { ReactNode } from 'react';
import { cn } from '../utils';

export interface FooterSocialLinkProps {
  href: string;
  'aria-label': string;
  children: ReactNode;
}

export function FooterSocialLink({ href, 'aria-label': ariaLabel, children }: FooterSocialLinkProps) {
  return (
    <a
      data-slot="footer-social-link"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={ariaLabel}
      className={cn(
        'inline-flex size-6 items-center justify-center text-muted-foreground transition-colors',
        'hover:text-foreground',
        'focus-visible:rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
        '[&_svg]:size-6',
      )}
    >
      {children}
    </a>
  );
}
